var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Word"},[_c('div',{staticStyle:{"height":"100vh","width":"auto"},domProps:{"innerHTML":_vm._s(_vm.poHtmlCode)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }